import { HD_HEIGHT, HD_WIDTH } from "../constants";

export function hasVideoCorrectRes(width: number, height: number): boolean {
    return +width === HD_WIDTH && +height === HD_HEIGHT;
};